export function initializeSpoilers() {
  const spoilerElements = document.querySelectorAll(".spoiler");

  if (spoilerElements.length > 0) {
    spoilerElements.forEach((element) => {
      element.addEventListener("click", () => {
        element.classList.toggle("tagged");
      });

      element.addEventListener("touchstart", (event) => {
        element.classList.toggle("tagged");
        event.preventDefault();
      });
    });
  }
}
